import { html, LitElement } from "../vendor/lit-element/lit-element";
import { gsap } from "gsap";

class Disease extends LitElement {
  async firstUpdated() {
    // Give the browser a chance to paint
    await new Promise((r) => setTimeout(r, 0));
    var target = { val: 1 };

    const tl = gsap
      .timeline()
      .to(this, {
        opacity: 1,
      })
      .set(
        "#slider-handle",
        {
          x: 0,
        },
        "<"
      )
      .set(
        "#fill-clip > rect",
        {
          scaleY: 0.68,
        },
        "<"
      )
      // FIRST MOVE
      .fromTo(
        "#slider-handle",
        {
          translateX: 0,
        },
        {
          translateX: 55,
          duration: 0.5,
          ease: "circ.out",
          delay: 1,
        }
      )
      .fromTo(
        "#fill-clip > rect",
        {
          scaleY: 0.68,
        },
        {
          scaleY: 0.73,
          duration: 0.5,
        },
        "<"
      )
      .to(
        "#cv-number",
        {
          attr: { x: -20 },
          duration: 0.5,
        },
        "<"
      )
      .to(
        "#cv-number",
        {
          textContent: 1.12,
          duration: 0.5,
          snap: { textContent: 0.01 },
        },
        "<"
      )
      .set(
        ".cls-19",
        {
          attr: { x1: 89, x2: 144 },
          delay: 0.25,
        },
        "<"
      )
      .to(
        "#cv-range",
        {
          opacity: 0,
          duration: 0.25,
        },
        "<"
      )
      .set(
        "#cv-range",
        {
          textContent: ">0-0.5",
          x: 70,
          delay: 0.25,
        },
        "<"
      )
      .to(
        "#cv-range",
        {
          opacity: 1,
          duration: 0.25,
          delay: 0.25,
        },
        "<"
      )
      // SECOND MOVE
      .fromTo(
        "#slider-handle",
        {
          translateX: 55,
        },
        {
          translateX: 110,
          duration: 0.5,
          ease: "circ.out",
          delay: 2,
        }
      )
      .fromTo(
        "#fill-clip > rect",
        {
          scaleY: 0.73,
        },
        {
          scaleY: 0.78,
          duration: 0.5,
        },
        "<"
      )
      .to(
        "#cv-number",
        {
          textContent: 1.26,
          duration: 0.5,
          snap: { textContent: 0.01 },
        },
        "<"
      )
      .set(
        ".cls-19",
        {
          attr: { x1: 144, x2: 199 },
          delay: 0.25,
        },
        "<"
      )
      .to(
        "#cv-range",
        {
          opacity: 0,
          duration: 0.25,
        },
        "<"
      )
      .set(
        "#cv-range",
        {
          textContent: ">0.5-1",
          x: 125,
          delay: 0.25,
        },
        "<"
      )
      .to(
        "#cv-range",
        {
          opacity: 1,
          duration: 0.25,
          delay: 0.25,
        },
        "<"
      )
      // THIRD MOVE
      .fromTo(
        "#slider-handle",
        {
          translateX: 110,
        },
        {
          translateX: 190,
          duration: 0.5,
          ease: "circ.out",
          delay: 2,
        }
      )
      .fromTo(
        "#fill-clip > rect",
        {
          scaleY: 0.78,
        },
        {
          scaleY: 0.83,
          duration: 0.5,
        },
        "<"
      )
      .to(
        "#cv-number",
        {
          textContent: 1.43,
          duration: 0.5,
          snap: { textContent: 0.01 },
        },
        "<"
      )
      .set(
        ".cls-19",
        {
          attr: { x1: 200, x2: 310 },
          delay: 0.25,
        },
        "<"
      )
      .to(
        "#cv-range",
        {
          opacity: 0,
          duration: 0.25,
        },
        "<"
      )
      .set(
        "#cv-range",
        {
          textContent: ">1-2",
          x: 220,
          delay: 0.25,
        },
        "<"
      )
      .to(
        "#cv-range",
        {
          opacity: 1,
          duration: 0.25,
          delay: 0.25,
        },
        "<"
      )
      // FOURTH MOVE
      .fromTo(
        "#slider-handle",
        {
          translateX: 190,
        },
        {
          translateX: 270,
          duration: 0.5,
          ease: "circ.out",
          delay: 2,
        }
      )
      .fromTo(
        "#fill-clip > rect",
        {
          scaleY: 0.83,
        },
        {
          scaleY: 1,
          duration: 0.5,
        },
        "<"
      )
      .to(
        "#cv-number",
        {
          textContent: 2.03,
          duration: 0.5,
          snap: { textContent: 0.01 },
        },
        "<"
      )
      .set(
        ".cls-19",
        {
          attr: { x1: 310, x2: 365 },
          delay: 0.25,
        },
        "<"
      )
      .to(
        "#cv-range",
        {
          opacity: 0,
          duration: 0.25,
        },
        "<"
      )
      .set(
        "#cv-range",
        {
          textContent: ">2",
          x: 320,
          delay: 0.25,
        },
        "<"
      )
      .to(
        "#cv-range",
        {
          opacity: 1,
          duration: 0.25,
          delay: 0.25,
        },
        "<"
      )
      .play();
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html`<svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 395.3 396.06"
    >
      <defs>
        <style>
          .cls-1,
          .cls-12,
          .cls-14,
          .cls-16,
          .cls-19,
          .cls-87 {
            fill: none;
          }
          .cls-2 {
            isolation: isolate;
          }
          .cls-3 {
            fill: #4d21b5;
            opacity: 0.67;
          }
          .cls-15,
          .cls-4 {
            font-size: 33px;
            font-family: Barlow-ExtraBold, Barlow;
            font-weight: 800;
          }
          .cls-18,
          .cls-4 {
            fill: #fff;
          }
          .cls-5,
          .cls-71 {
            font-size: 20px;
          }
          .cls-5 {
            font-family: Barlow-Bold, Barlow;
            font-weight: 700;
          }
          .cls-6 {
            letter-spacing: -0.01em;
          }
          .cls-7 {
            letter-spacing: 0em;
          }
          .cls-8 {
            letter-spacing: -0.02em;
          }
          .cls-9 {
            letter-spacing: 0em;
          }
          .cls-10 {
            letter-spacing: -0.01em;
          }
          .cls-11,
          .cls-13 {
            fill: #231f20;
          }
          .cls-11 {
            opacity: 0.09;
          }
          .cls-12 {
            stroke: #231f20;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 0.47px;
          }
          .cls-13 {
            opacity: 0.3;
            mix-blend-mode: multiply;
          }
          .cls-14 {
            stroke: #1c1463;
            stroke-width: 0.75px;
          }
          .cls-14,
          .cls-16,
          .cls-19,
          .cls-87 {
            stroke-miterlimit: 10;
          }
          .cls-15,
          .cls-32 {
            fill: #38a947;
          }
          .cls-16 {
            stroke: #b1b1b1;
          }
          .cls-16,
          .cls-19 {
            stroke-width: 4.35px;
          }
          .cls-17 {
            fill: #b1b1b1;
          }
          .cls-19 {
            stroke: #8cf58c;
          }
          .cls-20 {
            font-size: 12px;
            fill: #575756;
            font-family: Barlow-Medium, Barlow;
            font-weight: 500;
          }
          .cls-21 {
            clip-path: url(#clip-path);
          }
          .cls-22 {
            fill: #84ca8d;
          }
          .cls-23 {
            fill: #80c889;
          }
          .cls-24 {
            fill: #7cc685;
          }
          .cls-25 {
            fill: #77c481;
          }
          .cls-26 {
            fill: #72c27d;
          }
          .cls-27 {
            fill: #6dc078;
          }
          .cls-28 {
            fill: #68be73;
          }
          .cls-29 {
            fill: #61bb6d;
          }
          .cls-30 {
            fill: #5ab866;
          }
          .cls-31 {
            fill: #50b35d;
          }
          .cls-33 {
            fill: #37a646;
          }
          .cls-34 {
            fill: #36a244;
          }
          .cls-35 {
            fill: #359f43;
          }
          .cls-36 {
            fill: #349b41;
          }
          .cls-37 {
            fill: #329840;
          }
          .cls-38 {
            fill: #31953e;
          }
          .cls-39 {
            fill: #30913d;
          }
          .cls-40 {
            fill: #2f8e3c;
          }
          .cls-41 {
            fill: #2e8b3a;
          }
          .cls-42 {
            fill: #2d8739;
          }
          .cls-43 {
            fill: #2c8437;
          }
          .cls-44 {
            fill: #2b8036;
          }
          .cls-45 {
            fill: #297d35;
          }
          .cls-46 {
            fill: #287a33;
          }
          .cls-47 {
            fill: #277632;
          }
          .cls-48 {
            fill: #267330;
          }
          .cls-49 {
            fill: #25702f;
          }
          .cls-50 {
            fill: #246c2d;
          }
          .cls-51 {
            fill: #23692c;
          }
          .cls-52 {
            fill: #22652b;
          }
          .cls-53 {
            fill: #206229;
          }
          .cls-54 {
            fill: #1f5f28;
          }
          .cls-55 {
            fill: #1e5b26;
          }
          .cls-56 {
            fill: #1d5825;
          }
          .cls-57 {
            clip-path: url(#clip-path-2);
          }
          .cls-58 {
            clip-path: url(#clip-path-3);
          }
          .cls-59 {
            fill: #31933e;
          }
          .cls-60 {
            clip-path: url(#clip-path-4);
          }
          .cls-61 {
            fill: #87cb90;
          }
          .cls-62 {
            fill: #8bcd93;
          }
          .cls-63 {
            fill: #8ece97;
          }
          .cls-64 {
            fill: #91d09a;
          }
          .cls-65 {
            fill: #94d19d;
          }
          .cls-66 {
            fill: #98d29f;
          }
          .cls-67 {
            fill: #9ad4a2;
          }
          .cls-68 {
            fill: #9dd5a5;
          }
          .cls-69 {
            fill: #a0d6a7;
          }
          .cls-70 {
            clip-path: url(#clip-path-5);
          }
          .cls-71 {
            fill: #6f6f6e;
            font-family: Barlow-Regular, Barlow;
          }
          .cls-72 {
            letter-spacing: -0.01em;
          }
          .cls-73 {
            letter-spacing: -0.01em;
          }
          .cls-74 {
            letter-spacing: -0.01em;
          }
          .cls-75 {
            letter-spacing: -0.01em;
          }
          .cls-76 {
            letter-spacing: 0em;
          }
          .cls-77 {
            letter-spacing: -0.01em;
          }
          .cls-78 {
            letter-spacing: -0.02em;
          }
          .cls-79 {
            letter-spacing: -0.02em;
          }
          .cls-80 {
            letter-spacing: 0em;
          }
          .cls-81 {
            letter-spacing: -0.01em;
          }
          .cls-82 {
            letter-spacing: -0.07em;
          }
          .cls-83 {
            letter-spacing: -0.01em;
          }
          .cls-84 {
            letter-spacing: 0em;
          }
          .cls-85 {
            letter-spacing: 0.01em;
          }
          .cls-86 {
            letter-spacing: -0.04em;
          }
          .cls-87 {
            stroke: #d9d9d9;
            stroke-width: 2px;
          }
          .cls-88 {
            clip-path: url(#fill-clip);
          }
        </style>
        <clipPath id="clip-path" transform="translate(0 -0.46)">
          <path
            class="cls-1"
            d="M62.35,214.43h5a7,7,0,0,1-14,0h5a2,2,0,0,0,4,0Z"
          />
        </clipPath>
        <clipPath id="clip-path-2" transform="translate(0 -0.46)">
          <path class="cls-1" d="M62.35,191.61h5v22.82h-5Z" />
        </clipPath>
        <clipPath id="clip-path-3" transform="translate(0 -0.46)">
          <path class="cls-1" d="M58.39,214.43h-5V191.61h5Z" />
        </clipPath>
        <clipPath id="clip-path-4" transform="translate(0 -0.46)">
          <path
            class="cls-1"
            d="M60.37,189.63v-5a7,7,0,0,1,7,7h-5A2,2,0,0,0,60.37,189.63Z"
          />
        </clipPath>
        <clipPath id="clip-path-5" transform="translate(0 -0.46)">
          <path
            class="cls-1"
            d="M58.39,191.61h-5a7,7,0,0,1,7-7v5A2,2,0,0,0,58.39,191.61Z"
          />
        </clipPath>
        <clipPath id="fill-clip" transform="translate(0 -0.46)">
          <rect
            class="cls-1"
            x="76.53"
            width="80.42"
            height="137.53"
            style="fill: none; transform-origin: bottom;"
          />
        </clipPath>
      </defs>
      <g class="cls-2">
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_2-2" data-name="Layer 2">
            <circle class="cls-3" cx="253.38" cy="68.41" r="66.08" />
            <text class="cls-4" transform="translate(245.52 60.52)">
              <tspan x="0" id="cv-number">1</tspan>
              <tspan class="cls-5">
                <tspan x="-24.54" y="22">Risk</tspan>
                <tspan class="cls-6" x="17.66" y="22">o</tspan>
                <tspan class="cls-7" x="28.52" y="22">f</tspan>
                <tspan class="cls-8" x="-33.77" y="41">C</tspan>
                <tspan class="cls-9" x="-21.91" y="41">V de</tspan>
                <tspan class="cls-10" x="16.61" y="41">a</tspan>
                <tspan x="26.95" y="41">th</tspan>
              </tspan>
            </text>
            <path
              class="cls-11"
              d="M151.34,76.54l-.7-6.91a24.47,24.47,0,0,0-3.08-9.19,3.73,3.73,0,0,0,2.84.3A4,4,0,0,0,152.74,56c-.62-2.12-3.23-2.12-3.23-2.12a3.84,3.84,0,0,0,.37-3.79,3.43,3.43,0,0,0-3.44-2,11,11,0,0,0,2.12-3,5.15,5.15,0,0,0-1-5.81l-2.62-1a22.24,22.24,0,0,0,.9-7.79c-.94-7.9-3.57-6.42-4.36-8.4s1.1-4.77,1.1-4.77l4.89-5.82a3.29,3.29,0,0,0-2.67-2.22s-3.71,4.19-5.38,6-3.56,4.26-3.88,3a4.94,4.94,0,0,1,.11-2.49l4.61-8.93c-1.06-1.88-4.5-1.61-4.5-1.61s-5.46,7.64-6.32,8.65-3.27,1.44-3.27,1.44a27.62,27.62,0,0,1-5-.89c-1.6-.57-1.17-2.44-1.17-2.44l0-11a4,4,0,0,0-3.83.28l-.28,5.32c-.82,7.3-2.88,9.38-2.88,9.38l-3.16,1.5a5.78,5.78,0,0,0-1.42-4.67,3.4,3.4,0,0,0-3.77-1.39l-3.41,2.81c-1.57-.76-3.06-3.23-3.06-3.23C95.69,7.57,92.63,2.4,92.63,2.4a17.67,17.67,0,0,0-5.48,3,6.69,6.69,0,0,0-2.66,5.34c1.69,1.82,7.64,13,7.64,13C96.71,34.4,94.5,42,93.61,46S87.5,59.86,87.5,59.86a57.93,57.93,0,0,0-6.08,15.71c-1.78,8.49,1.61,14,1.61,14l-.93,3.92c-3.58,12.36,3.67,18.33,8.2,23.36s20.26,15.26,23.5,16.94,5.83,6.78,14.21-.88,14.08-17,18.36-25.06,6.49-27.32,6.59-29.51S151.34,76.54,151.34,76.54Zm-36-46.27c1.56-2.07,4.64-2,4.64-2,9.68-1,13.53,4,13.53,4L135,34.5C122.75,30.34,115.32,30.27,115.32,30.27Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-12"
              d="M109.78,17.56l3.16-1.5S115,14,115.82,6.68l.28-5.32a4,4,0,0,1,3.83-.28l0,11s-.43,1.87,1.17,2.44a27.62,27.62,0,0,0,5,.89s2.41-.43,3.27-1.44,6.32-8.65,6.32-8.65,3.44-.27,4.49,1.61l-4.6,8.93a4.94,4.94,0,0,0-.11,2.49c.32,1.21,2.21-1.25,3.88-3s5.38-6,5.38-6a3.29,3.29,0,0,1,2.67,2.22l-4.89,5.82s-1.9,2.79-1.1,4.77,3.42.5,4.36,8.4a22.24,22.24,0,0,1-.9,7.79l2.62,1a5.15,5.15,0,0,1,1,5.81,11,11,0,0,1-2.12,3,3.43,3.43,0,0,1,3.44,2,3.84,3.84,0,0,1-.37,3.79s2.61,0,3.23,2.12a4,4,0,0,1-2.34,4.79,3.73,3.73,0,0,1-2.84-.3,24.47,24.47,0,0,1,3.08,9.19l.7,6.91s1.71-.41,1.62,1.78-2.31,21.47-6.59,29.51-10,17.4-18.36,25.06-11,2.55-14.21.88-19-11.91-23.5-16.94-11.78-11-8.2-23.36L83,89.55s-3.39-5.49-1.61-14A57.93,57.93,0,0,1,87.5,59.86s5.22-10,6.11-13.91,3.1-11.55-1.48-22.2c0,0-5.95-11.19-7.64-13A6.69,6.69,0,0,1,87.15,5.4a17.67,17.67,0,0,1,5.48-3s3.06,5.17,5.49,8.68c0,0,1.49,2.47,3.06,3.23l3.41-2.81a3.4,3.4,0,0,1,3.77,1.39A5.78,5.78,0,0,1,109.78,17.56Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M105.62,12.75a2.42,2.42,0,0,1,1.81,1,4.74,4.74,0,0,1,.84,2.06,3.25,3.25,0,0,1,0,1.52,1.38,1.38,0,0,1-1,1,1.64,1.64,0,0,1-1.35-.64,5.1,5.1,0,0,1-1.34-2.91,2.37,2.37,0,0,1,.19-1.42C105,13,105.13,12.75,105.62,12.75Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M146.32,40.5a2.07,2.07,0,0,0-.72-.19,4.67,4.67,0,0,0-2.64.57,5.94,5.94,0,0,0-2.31,2.57,5.32,5.32,0,0,0-.72,2.84,2.78,2.78,0,0,0,1.55,2.38,3.32,3.32,0,0,0,2.79-.3c2.15-1.11,3.78-4,3.15-6.44A2.09,2.09,0,0,0,146.32,40.5Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M147.77,49.62a1.33,1.33,0,0,0-1.14-.19,3.22,3.22,0,0,0-1.06.6,4.32,4.32,0,0,0-1.18,1.36,2.84,2.84,0,0,0-.3,1.9,2,2,0,0,0,1.66,1.57,2.39,2.39,0,0,0,2-1,3.57,3.57,0,0,0,.8-2.32A2.79,2.79,0,0,0,147.77,49.62Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M151.08,55.33a1.26,1.26,0,0,0-1.08-.17,2.9,2.9,0,0,0-1,.55A4.3,4.3,0,0,0,147.85,57a2.62,2.62,0,0,0-.28,1.76,1.85,1.85,0,0,0,1.59,1.46,2.33,2.33,0,0,0,1.91-.94,3.35,3.35,0,0,0,.77-2.15A2.55,2.55,0,0,0,151.08,55.33Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M107.43,48.36S103,43.57,101.5,38.29,100,30.13,103,25.46s8.56-6.38,8.56-6.38a6,6,0,0,0,2.87-2.25c1.19-1.74,3.24-10.83,1.67-15,0,0-.28,11.46-3.13,14.19l-2.28,1.18a5.49,5.49,0,0,0-2.08,1.86h0s-9.77,4.84-10.3,13.69,7.92,16.64,7.92,16.64l1.23-1.07"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M118.82.73,118.28,15s-.87.86,2,1.41,6.89,1.12,8.12.47,4.4-6.16,4.81-6.38,2.52-5.22,2.52-5.22l-6.61,8.89a7.27,7.27,0,0,1-4.53,1c-.32-.05-3.47-.72-3.47-.72S120,14.65,120,11l0-9.95Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M139.92,6.48a43.71,43.71,0,0,1-2.77,4.62c-2.15,1.8-3.31,5.16-3.82,7.78a1.31,1.31,0,0,0,0,.34.73.73,0,0,0,.15.32,2.12,2.12,0,0,0,1.74.54h1.23a1.79,1.79,0,0,0,.65-.08c.82-.31,1.76-2.19,2.29-2.89s1-1.35,1.52-2l4.43-5.66-.54-.14-6.41,7.14-2.6,2.21a2.35,2.35,0,0,1-.14-2.8l3.24-6.28,1.36-2.65Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M147,10.62s-3.8,4.47-4.45,5.27-2.66,4.19-2.66,4.19-1.2,1.46-.61,2.33a21.51,21.51,0,0,0,2.25,2.4A8.06,8.06,0,0,1,144,30.27a45.38,45.38,0,0,1-1.31,7.14l2.18.88s1.87-5.77.5-10.24-3.77-5.58-3.77-5.58-1.43-1.68.34-4.12,4.72-6,4.72-6l.74-.87Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M119.12,30.58s-2.51,7.26-1.32,11h0l-.86.33s-3.15-3.66-3.12-6.49a9.74,9.74,0,0,1,1.56-5l3.74.12"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M85,8.12l9.43,14.27s3.08,3,1.87,15.9S92,56.47,89.41,60.71,82.3,80.86,84.77,84.76a55.78,55.78,0,0,0,.7,13.4c1.27,7.18,6.14,14.71,9.26,18.15s21.78,15.48,21.93,15.59,3.75,2.47,9-1,18-20.93,19.65-24.83,7.68-24.7,6.49-29.45c0,0,1.37.28,1.16,2.08s-1.71,13-2.71,17-2.71,9.86-3.78,11.86-7.85,13-7.85,13L128.28,132.8s-6.35,7.15-11.65,2.88h0l-10.92-6.94s-9.08-6.14-13.6-10.12-9-9-10.19-14a26.58,26.58,0,0,1,0-10.27l1-5.13s-2.28-4.18-2.08-7.69A42.92,42.92,0,0,1,82,73c.56-1.91,4-10.47,4-10.47s2.4-5,4.13-8.11a37,37,0,0,0,4.43-13.54c.5-5.26.41-9.65-1.69-15.14a90.23,90.23,0,0,0-5.45-10.23l-3-4.81A7.22,7.22,0,0,1,85,8.12Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M104.71,15.55s1.22-1,3.56.29h0s-.43-2.82-2.65-3.09-.91,2.8-.91,2.8"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M140.88,43l6.27,2s1.06-3-.26-4.11-4.37-.26-6,2.11"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M144.22,51.78l3.53,2.07s1.81-3,0-4.23c-1.41-.93-3.05,1.26-3.05,1.26Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M147.85,57l3.22,2.28s1.59-2.41,0-3.92S147.85,57,147.85,57"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M113.78,43.53s-7.37-8.9-2.85-14.32a13.67,13.67,0,0,1,10.38-4.73,19.77,19.77,0,0,1,6,1,20.75,20.75,0,0,1,5.46,2.36,13,13,0,0,1,3.68,3.88,16.4,16.4,0,0,1,1.72,3.93L135,34.49s-2.36-5.8-11.52-6.27h0s-6.8-.82-8.79,2.89h0s-3.33,5,2.41,10.59l-3.36,1.83"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M90,3.52l8.51,13.72,2.63-2.93s-.46.48-5.21-6.48L92.63,2.4Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M123.22,42.26s-2.64-1-2.88-1.39,2.39.16,2.39.16l16,3.9a1,1,0,0,1,.41.89,6.37,6.37,0,0,0,.28,1.89c.6,1.52,1.64,1.67,1.64,1.67Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M144.67,55.19s.63,1.07,3.18-.08c0,0-1.75,2.11-1.25,3.42h0l-1.93-3.34"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M141.09,49.72a6.33,6.33,0,0,0,3.44-.34s-1.94,2.07-1.47,3.54Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M130.17,130.55a.11.11,0,0,1,.15.16,25.93,25.93,0,0,1-4.3,3.94c-1.79,1.31-4,2.59-6.19,2.34-2-.22-3.68-1.69-5.35-2.72a198.74,198.74,0,0,1-17.62-11.79c-5.24-4.06-11.49-10-13.89-15.29a19,19,0,0,1-1.75-5.4c-.7-4.69,1.22-11.31,2.63-15.78,2.09-6.62,5.61-12.68,9.1-18.68-2.63,7.63-5.23,15.4-5.68,23.45s1.49,16.58,7,22.52c4.29,4.67,10.29,7.33,15.45,11,3.24,2.32,6.23,5.1,9.9,6.66C122.86,132.39,127.41,132.47,130.17,130.55Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M103.55,21.8a16.63,16.63,0,0,0-4.34,21c1.21,2.22,3,4.36,3,6.89s-2.09,4.82-3.9,6.79a73.89,73.89,0,0,0-13.91,21.8c-.28.69-.66,1.48-1.39,1.64a1.59,1.59,0,0,1-1.69-1.17,4.6,4.6,0,0,1,0-2.24A17.68,17.68,0,0,0,82.75,89,117.77,117.77,0,0,1,106.2,49.43,17.57,17.57,0,0,1,105,21.17,11.51,11.51,0,0,0,103.55,21.8Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M124.13,54.05a36.91,36.91,0,0,0-6.56,8.4c-1.62,3.18-2.28,7-.95,10.33C118.13,76.53,122,79,126,79.71s8.07,0,12-1,7.77-2.32,11.77-2.82a2.94,2.94,0,0,1,2.39.43c-4.54.79-8.86,2.52-13.27,3.85s-9.09,2.26-13.62,1.41-8.9-3.81-10.31-8.2c-1.15-3.59-.17-7.59,1.75-10.84S121.34,56.69,124.13,54.05Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M149.29,64.79A82.9,82.9,0,0,0,142,54.27c-1.54-1.88-3.27-3.77-5.58-4.53a9.25,9.25,0,0,0-5.65.19,27,27,0,0,0-5.17,2.49,23.29,23.29,0,0,1,7.34-3.66c2.42-.6,5.45-.65,7.56.62a1.53,1.53,0,0,1,.57.46c1,1.56,2.09,2.81,3,4.32C146.13,57.61,148.23,61.11,149.29,64.79Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M137.15,35.17A11.89,11.89,0,0,0,132,28.73a18.44,18.44,0,0,0-8-2.56,15.28,15.28,0,0,0-6.17.44,8.4,8.4,0,0,0-4.83,3.7c-1.61,2.85-1,6.44.17,9.51a4.46,4.46,0,0,0,1.5,2.29,1.7,1.7,0,0,0,2.42-.41,11.76,11.76,0,0,1-3.29-5.17,6.66,6.66,0,0,1,1-5.89,6.91,6.91,0,0,1,4-2.27,15.82,15.82,0,0,1,4.66-.15c3.62.31,7.48,1.21,9.87,3.94C134.52,33.46,135.49,35.25,137.15,35.17Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-13"
              d="M121.82,31a21.61,21.61,0,0,0-3.66,10.52l-1.22.47s-5.87-6-1.6-11.9Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-12"
              d="M105.62,12.75a2.42,2.42,0,0,1,1.81,1,4.74,4.74,0,0,1,.84,2.06,3.25,3.25,0,0,1,0,1.52,1.38,1.38,0,0,1-1,1,1.64,1.64,0,0,1-1.35-.64,5.1,5.1,0,0,1-1.34-2.91,2.37,2.37,0,0,1,.19-1.42C105,13,105.13,12.75,105.62,12.75Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-12"
              d="M105.93,49.67a30.42,30.42,0,0,1-6.4-9.23,15.3,15.3,0,0,1-.49-11,18.39,18.39,0,0,1,1.58-3.64,20.18,20.18,0,0,1,6.17-5.53c1.27-.77,2.66-1.41,3.07-3"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-12"
              d="M135,34.49a10.48,10.48,0,0,0-5-4.67,20.29,20.29,0,0,0-6.74-1.67c-2.61-.25-5.5-.15-7.46,1.6A6.83,6.83,0,0,0,114,36.07a12,12,0,0,0,3,5.88"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-12"
              d="M120,40.92c-8.16,2.18-14.43,8.66-19.51,15.41A110.14,110.14,0,0,0,83,89.55"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-12"
              d="M141.06,49.68c-3.75-2.13-8.59-1.49-12.35.61s-6.65,5.46-9.3,8.86a29.07,29.07,0,0,0-4.16,6.59,11.18,11.18,0,0,0-.57,7.63,11.91,11.91,0,0,0,5.83,6.36,19.72,19.72,0,0,0,11.61,2.33c6.72-.74,12.7-4.9,19.42-5.61"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-12"
              d="M144.91,38.29c-9.77-3.94-19-7.5-29.53-8"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-12"
              d="M146.32,40.5a2.07,2.07,0,0,0-.72-.19,4.67,4.67,0,0,0-2.64.57,5.94,5.94,0,0,0-2.31,2.57,5.32,5.32,0,0,0-.72,2.84,2.78,2.78,0,0,0,1.55,2.38,3.32,3.32,0,0,0,2.79-.3c2.15-1.11,3.78-4,3.15-6.44A2.09,2.09,0,0,0,146.32,40.5Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-12"
              d="M147.77,49.62a1.33,1.33,0,0,0-1.14-.19,3.22,3.22,0,0,0-1.06.6,4.32,4.32,0,0,0-1.18,1.36,2.84,2.84,0,0,0-.3,1.9,2,2,0,0,0,1.66,1.57,2.39,2.39,0,0,0,2-1,3.57,3.57,0,0,0,.8-2.32A2.79,2.79,0,0,0,147.77,49.62Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-12"
              d="M151.08,55.33a1.26,1.26,0,0,0-1.08-.17,2.9,2.9,0,0,0-1,.55A4.3,4.3,0,0,0,147.85,57a2.62,2.62,0,0,0-.28,1.76,1.85,1.85,0,0,0,1.59,1.46,2.33,2.33,0,0,0,1.91-.94,3.35,3.35,0,0,0,.77-2.15A2.55,2.55,0,0,0,151.08,55.33Z"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-12"
              d="M141.06,49.68A5.73,5.73,0,0,0,146.5,48"
              transform="translate(0 -0.46)"
            />
            <path
              class="cls-12"
              d="M147.56,60.44c-2.33-4.29-3.53-5.87-6.68-10.86"
              transform="translate(0 -0.46)"
            />
            <line class="cls-14" x1="150.64" y1="68.41" x2="187.3" y2="68.41" />
            <text
              id="cv-range"
              class="cls-15"
              transform="translate(43.02 255.68)"
            >
              &lt;0
            </text>
            <line
              class="cls-16"
              x1="37.94"
              y1="202.56"
              x2="357.6"
              y2="202.56"
            />
            <rect
              class="cls-17"
              x="87.51"
              y="192.88"
              width="7.35"
              height="19.36"
            />
            <path
              class="cls-18"
              d="M93.35,194.84V211.2H89V194.84h4.34m3-3H86V214.2H96.35V191.84Z"
              transform="translate(0 -0.46)"
            />
            <rect
              class="cls-17"
              x="140.74"
              y="192.88"
              width="7.35"
              height="19.36"
            />
            <path
              class="cls-18"
              d="M146.59,194.84V211.2h-4.35V194.84h4.35m3-3H139.24V214.2h10.35V191.84Z"
              transform="translate(0 -0.46)"
            />
            <rect
              class="cls-17"
              x="193.98"
              y="192.88"
              width="7.35"
              height="19.36"
            />
            <path
              class="cls-18"
              d="M199.82,194.84V211.2h-4.34V194.84h4.34m3-3H192.48V214.2h10.34V191.84Z"
              transform="translate(0 -0.46)"
            />
            <rect
              class="cls-17"
              x="247.21"
              y="192.88"
              width="7.35"
              height="19.36"
            />
            <path
              class="cls-18"
              d="M253.06,194.84V211.2h-4.35V194.84h4.35m3-3H245.71V214.2h10.35V191.84Z"
              transform="translate(0 -0.46)"
            />
            <rect
              class="cls-17"
              x="300.45"
              y="192.88"
              width="7.35"
              height="19.36"
            />
            <path
              class="cls-18"
              d="M306.3,194.84V211.2H302V194.84h4.35m3-3H299V214.2H309.3V191.84Z"
              transform="translate(0 -0.46)"
            />
            <line
              id=""
              class="cls-19"
              x1="37.94"
              y1="202.56"
              x2="89.01"
              y2="202.56"
            />
            <rect
              class="cls-17"
              x="87.51"
              y="192.88"
              width="7.35"
              height="19.36"
            />
            <path
              class="cls-18"
              d="M93.35,194.84V211.2H89V194.84h4.34m3-3H86V214.2H96.35V191.84Z"
              transform="translate(0 -0.46)"
            />
            <rect
              class="cls-17"
              x="140.74"
              y="192.88"
              width="7.35"
              height="19.36"
            />
            <path
              class="cls-18"
              d="M146.59,194.84V211.2h-4.35V194.84h4.35m3-3H139.24V214.2h10.35V191.84Z"
              transform="translate(0 -0.46)"
            />
            <rect
              class="cls-17"
              x="193.98"
              y="192.88"
              width="7.35"
              height="19.36"
            />
            <path
              class="cls-18"
              d="M199.82,194.84V211.2h-4.34V194.84h4.34m3-3H192.48V214.2h10.34V191.84Z"
              transform="translate(0 -0.46)"
            />
            <rect
              class="cls-17"
              x="247.21"
              y="192.88"
              width="7.35"
              height="19.36"
            />
            <path
              class="cls-18"
              d="M253.06,194.84V211.2h-4.35V194.84h4.35m3-3H245.71V214.2h10.35V191.84Z"
              transform="translate(0 -0.46)"
            />
            <rect
              class="cls-17"
              x="300.45"
              y="192.88"
              width="7.35"
              height="19.36"
            />
            <path
              class="cls-18"
              d="M306.3,194.84V211.2H302V194.84h4.35m3-3H299V214.2H309.3V191.84Z"
              transform="translate(0 -0.46)"
            />
            <text class="cls-20" transform="translate(87.78 188.75)">0</text>
            <text class="cls-20" transform="translate(136.26 188.75)">0.5</text>
            <text class="cls-20" transform="translate(195.59 188.75)">1</text>
            <text class="cls-20" transform="translate(244.07 188.75)">1.5</text>
            <text class="cls-20" transform="translate(300.86 188.75)">2</text>
            <g id="slider-handle" class="cls-2">
              <g class="cls-2">
                <g class="cls-21">
                  <g class="cls-2">
                    <path
                      class="cls-22"
                      d="M62.35,214.43h5a7,7,0,0,1-14,0h5a2,2,0,0,0,4,0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-22"
                      d="M58.39,214.43a2,2,0,0,0,4,0h5a7,7,0,0,1-14,0h5"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-23"
                      d="M58.39,214.43a2,2,0,0,0,4,0h.21s0,.06,0,.06.06,0,.09-.06h4.66a7,7,0,0,1-14,0h5"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-24"
                      d="M58.39,214.43a2,2,0,0,0,4,0h.19s0,.09.05.1.12-.07.17-.1h4.59a7,7,0,0,1-14,0h5"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-25"
                      d="M58.39,214.43a2,2,0,0,0,4,0h.16s0,.13.08.14.16-.1.23-.14h4.53a7,7,0,0,1-14,0h5"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-26"
                      d="M58.39,214.43a2,2,0,0,0,4,0h.14a.75.75,0,0,1,.09.25c.09-.09.23-.13.28-.25h4.49a7,7,0,0,1-14,0h5"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-27"
                      d="M58.39,214.43a2,2,0,0,0,4,0h.12a1.51,1.51,0,0,1,.09.38,2.26,2.26,0,0,0,.33-.38h4.46a7,7,0,0,1-14,0h5"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-28"
                      d="M58.39,214.43a2,2,0,0,0,4,0h.09a1.38,1.38,0,0,1,.09.46c.28-.18.28-.18.4-.46h4.42a7,7,0,0,1-14,0h5"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-29"
                      d="M58.39,214.43a2,2,0,0,0,4,0h.07a4.07,4.07,0,0,1,.07.61.81.81,0,0,0,.47-.61h4.39a7,7,0,0,1-14,0h5"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-30"
                      d="M58.39,214.43a2,2,0,0,0,4,0h0c0,.25,0,.5,0,.75a1.09,1.09,0,0,0,.55-.75h4.36a7,7,0,0,1-14,0h5"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-31"
                      d="M58.39,214.43a2,2,0,0,0,4,0h0c0,.31-.43.86,0,.94a1.37,1.37,0,0,0,.63-.94h4.33a7,7,0,0,1-14,0h5"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-32"
                      d="M58.39,214.43s0,.1,0,.14a2,2,0,0,0,3.6,1s0-.09.09-.1.16,0,.22,0a1.7,1.7,0,0,0,.75-1.09h4.29a7,7,0,0,1-14,0h5"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-33"
                      d="M58.37,214.43s0,.1,0,.14a2,2,0,0,0,2,1.87c.78,0,2.5-.91,2.74-2h4.24a7,7,0,0,1-14,0h5"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-34"
                      d="M58.34,214.43s0,.1,0,.14a2.06,2.06,0,0,0,2,1.9,3.28,3.28,0,0,0,2.81-2h4.17a7,7,0,0,1-14,0h5"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-35"
                      d="M58.32,214.43s0,.1,0,.15a2.08,2.08,0,0,0,2,1.92,3.29,3.29,0,0,0,2.87-2.07h4.11a7,7,0,0,1-14,0h4.93"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-36"
                      d="M58.29,214.43s0,.1,0,.15a2.14,2.14,0,0,0,.57,1.27,2.1,2.1,0,0,0,1.51.68,3.35,3.35,0,0,0,2.94-2.1h4a7,7,0,0,1-14,0h4.9"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-37"
                      d="M58.27,214.43s0,.1,0,.15a2.1,2.1,0,0,0,.57,1.29,2.14,2.14,0,0,0,1.53.69,3.44,3.44,0,0,0,3.06-2.13h3.92a7,7,0,0,1-14,0h4.88"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-38"
                      d="M58.25,214.43s0,.11,0,.15a2.18,2.18,0,0,0,.68,1.41,2.26,2.26,0,0,0,1.6.6,3.53,3.53,0,0,0,3-2.16h3.81a7,7,0,0,1-14,0h4.86"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-39"
                      d="M58.22,214.43s0,.11,0,.15a2.22,2.22,0,0,0,.7,1.42,2.26,2.26,0,0,0,1.62.62,3.69,3.69,0,0,0,3.15-2.19h3.67a7,7,0,0,1-14,0h4.83"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-40"
                      d="M58.2,214.43s0,.11,0,.15a2.29,2.29,0,0,0,2.34,2.07,3.85,3.85,0,0,0,3.29-2.22h3.53a7,7,0,0,1-14,0H58.2"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-41"
                      d="M58.17,214.43s0,.11,0,.16a2.33,2.33,0,0,0,.71,1.45,2.49,2.49,0,0,0,1.66.65A4.11,4.11,0,0,0,64,214.43h3.38a7,7,0,0,1-14,0h4.78"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-42"
                      d="M58.15,214.43s0,.11,0,.16a2.43,2.43,0,0,0,.74,1.47,2.49,2.49,0,0,0,1.68.68,4.32,4.32,0,0,0,3.6-2.31h3.21a7,7,0,0,1-14,0h4.76"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-43"
                      d="M58.1,214.43s0,.11,0,.16a2.48,2.48,0,0,0,.75,1.5,2.55,2.55,0,0,0,1.71.69,4.49,4.49,0,0,0,3.77-2.35h3a7,7,0,0,1-14,0H58.1"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-44"
                      d="M58.05,214.43s0,.12,0,.17a2.5,2.5,0,0,0,.76,1.51,2.59,2.59,0,0,0,1.74.71,4.71,4.71,0,0,0,4-2.39h2.84a7,7,0,0,1-14,0h4.66"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-45"
                      d="M58,214.43s0,.12,0,.17a2.44,2.44,0,0,0,.89,1.65,2.67,2.67,0,0,0,1.83.62,5,5,0,0,0,4-2.44h2.62a7,7,0,0,1-14,0H58"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-46"
                      d="M58,214.43s0,.12,0,.17a2.65,2.65,0,0,0,.79,1.57,2.84,2.84,0,0,0,2,.76,5.23,5.23,0,0,0,4.25-2.5h2.37a7,7,0,0,1-14,0H58"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-47"
                      d="M57.91,214.43s0,.12,0,.17a2.75,2.75,0,0,0,.81,1.6,3.06,3.06,0,0,0,2,.8,5.61,5.61,0,0,0,4.52-2.57h2.09a7,7,0,0,1-14,0h4.52"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-48"
                      d="M57.84,214.43s0,.12,0,.18a2.93,2.93,0,0,0,2.9,2.45,6.12,6.12,0,0,0,4.84-2.63h1.76a7,7,0,0,1-14,0h4.45"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-49"
                      d="M57.77,214.43s0,.13,0,.18a3,3,0,0,0,1,1.78,3.24,3.24,0,0,0,2.17.76,6.63,6.63,0,0,0,5-2.72h1.39a7,7,0,0,1-14,0h4.38"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-50"
                      d="M57.71,214.43s0,.13,0,.19a3,3,0,0,0,1,1.82,3.53,3.53,0,0,0,2.23.79,7,7,0,0,0,5.4-2.8h1a7,7,0,0,1-14,0h4.32"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-51"
                      d="M57.63,214.43s0,.13,0,.19a3.14,3.14,0,0,0,1.18,2,3.71,3.71,0,0,0,2.38.73c1.06,0,4.36-.69,5.59-2.9h.55a7,7,0,0,1-14,0h4.24"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-52"
                      d="M57.54,214.43c.05,0,0,.14,0,.2a3.39,3.39,0,0,0,1.23,2,3.88,3.88,0,0,0,2.67.78c.62,0,4.88-.56,5.7-3h.19a7,7,0,0,1-14,0h4.15"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-53"
                      d="M57.45,214.43s0,.14,0,.21a3.32,3.32,0,0,0,1.42,2.21,4.77,4.77,0,0,0,2.87.72c.06,0,5.43-.28,5.59-3.14a7,7,0,0,1-14,0h4.06"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-54"
                      d="M57.32,214.43s0,.15,0,.22a4,4,0,0,0,1.19,2,4.44,4.44,0,0,0,2.79,1.05c.06,0,5.58.25,6-2.39a7,7,0,0,1-13.9-.92h3.93"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-55"
                      d="M57.18,214.43s0,.16,0,.23c0,.42.49,2.59,3.65,3.22.06,0,5.4.84,6.21-1.46a7,7,0,0,1-13.68-2h3.79"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-56"
                      d="M57,214.43s0,.17,0,.24A4.56,4.56,0,0,0,60.12,218c.05,0,5.35,1.61,6.48-.37a7,7,0,0,1-13.21-3.16H57"
                      transform="translate(0 -0.46)"
                    />
                  </g>
                </g>
              </g>
              <g class="cls-2">
                <g class="cls-57">
                  <g class="cls-2">
                    <path
                      class="cls-31"
                      d="M62.35,214.43V191.61h0v22.82h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-30"
                      d="M62.4,214.43V191.61h0v22.82h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-29"
                      d="M62.44,214.43V191.61h.05v22.82h-.05"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-28"
                      d="M62.49,214.43V191.61h0v22.82h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-27"
                      d="M62.54,214.43V191.61h0v22.82h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-26"
                      d="M62.58,214.43V191.61h.05v22.82h-.05"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-25"
                      d="M62.63,214.43V191.61h0v22.82h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-24"
                      d="M62.67,214.43V191.61h0v22.82h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-23"
                      d="M62.72,214.43V191.61h.08v22.82h-.08"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-24"
                      d="M62.8,214.43V191.61h0v22.82h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-25"
                      d="M62.84,214.43V191.61h0v22.82h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-26"
                      d="M62.87,214.43V191.61h0v22.82h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-27"
                      d="M62.91,214.43V191.61h0v22.82h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-28"
                      d="M62.94,214.43V191.61h0v22.82h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-29"
                      d="M63,214.43V191.61h0v22.82h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-30"
                      d="M63,214.43V191.61h0v22.82h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-31"
                      d="M63.05,214.43V191.61h0v22.82h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-32"
                      d="M63.09,214.43V191.61h0v22.82h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-33"
                      d="M63.12,214.43V191.61h0v22.82h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-34"
                      d="M63.16,214.43V191.61h.09v22.82h-.09"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-35"
                      d="M63.25,214.43V191.61h.1v22.82h-.1"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-36"
                      d="M63.35,214.43V191.61h.1v22.82h-.1"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-37"
                      d="M63.45,214.43V191.61h.09v22.82h-.09"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-38"
                      d="M63.54,214.43V191.61h.14v22.82h-.14"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-39"
                      d="M63.68,214.43V191.61h.15v22.82h-.15"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-40"
                      d="M63.83,214.43V191.61H64v22.82h-.14"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-41"
                      d="M64,214.43V191.61h.17v22.82H64"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-42"
                      d="M64.14,214.43V191.61h.17v22.82h-.17"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-43"
                      d="M64.31,214.43V191.61h.21v22.82h-.21"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-44"
                      d="M64.52,214.43V191.61h.21v22.82h-.21"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-45"
                      d="M64.73,214.43V191.61H65v22.82h-.24"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-46"
                      d="M65,214.43V191.61h.29v22.82H65"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-47"
                      d="M65.26,214.43V191.61h.33v22.82h-.33"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-48"
                      d="M65.59,214.43V191.61H66v22.82h-.37"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-49"
                      d="M66,214.43V191.61h.41v22.82H66"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-50"
                      d="M66.37,214.43V191.61h.43v22.82h-.43"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-51"
                      d="M66.8,214.43V191.61h.36v22.82H66.8"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-52"
                      d="M67.16,214.43V191.61h.19v22.82h-.19"
                      transform="translate(0 -0.46)"
                    />
                    <polyline
                      class="cls-53"
                      points="67.35 213.97 67.35 191.16 67.35 191.16 67.35 213.97 67.35 213.97"
                    />
                  </g>
                </g>
              </g>
              <g class="cls-2">
                <g class="cls-58">
                  <g class="cls-2">
                    <polyline
                      class="cls-31"
                      points="58.4 191.16 58.4 213.97 58.39 213.97 58.39 191.16 58.4 191.16"
                    />
                    <path
                      class="cls-32"
                      d="M58.39,191.61v22.82h0V191.61h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-33"
                      d="M58.36,191.61v22.82h0V191.61h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-34"
                      d="M58.33,191.61v22.82h0V191.61h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-35"
                      d="M58.3,191.61v22.82h0V191.61h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-36"
                      d="M58.27,191.61v22.82h0V191.61h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-37"
                      d="M58.24,191.61v22.82h0V191.61h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-38"
                      d="M58.21,191.61v22.82h0V191.61h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-39"
                      d="M58.18,191.61v22.82h0V191.61h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-40"
                      d="M58.15,191.61v22.82h0V191.61h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-41"
                      d="M58.12,191.61v22.82h0V191.61h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-42"
                      d="M58.09,191.61v22.82h0V191.61h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-43"
                      d="M58.06,191.61v22.82h0V191.61h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-44"
                      d="M58,191.61v22.82h0V191.61h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-45"
                      d="M58,191.61v22.82h0V191.61h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-46"
                      d="M58,191.61v22.82h-.07V191.61H58"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-47"
                      d="M57.89,191.61v22.82h-.07V191.61h.07"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-48"
                      d="M57.82,191.61v22.82h-.06V191.61h.06"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-49"
                      d="M57.76,191.61v22.82h-.07V191.61h.07"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-50"
                      d="M57.69,191.61v22.82h-.06V191.61h.06"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-51"
                      d="M57.63,191.61v22.82h-.09V191.61h.09"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-52"
                      d="M57.54,191.61v22.82h-.12V191.61h.12"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-53"
                      d="M57.42,191.61v22.82H57.3V191.61h.12"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-54"
                      d="M57.3,191.61v22.82h-.12V191.61h.12"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-55"
                      d="M57.18,191.61v22.82h-.26V191.61h.26"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-56"
                      d="M56.92,191.61v22.82H53.39V191.61h3.53"
                      transform="translate(0 -0.46)"
                    />
                  </g>
                </g>
              </g>
              <path
                class="cls-59"
                d="M60.37,189.63a2,2,0,0,1,2,2v22.82a2,2,0,0,1-4,0V191.61A2,2,0,0,1,60.37,189.63Z"
                transform="translate(0 -0.46)"
              />
              <g class="cls-2">
                <g class="cls-60">
                  <g class="cls-2">
                    <path
                      class="cls-22"
                      d="M60.37,189.63v-5a7,7,0,0,1,7,7h-5a2,2,0,0,0-2-2"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-22"
                      d="M62.71,191.61c-.05-.05,0-.17,0-.24a1.69,1.69,0,0,0-1.91-2c.35.36.85.54,1.17.93,0,0,.69,1,.64,1.35h-.3a2,2,0,0,0-2-2v-5a7,7,0,0,1,7,7H62.71"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-23"
                      d="M62.75,191.61c0-.05,0-.17,0-.25a1.74,1.74,0,0,0-2.06-2.05c.36.4.9.55,1.25,1,.08.09.61,1.22.61,1.23a.49.49,0,0,1,0,.11h-.21a2,2,0,0,0-2-2v-5a7,7,0,0,1,7,7h-4.6"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-24"
                      d="M62.78,191.61c-.05-.06,0-.18.07-.25a1.84,1.84,0,0,0-.48-1.57,1.65,1.65,0,0,0-1.74-.49.56.56,0,0,0,.28.23,2.35,2.35,0,0,1,1.6,2.08h-.16a2,2,0,0,0-2-2v-5a7,7,0,0,1,7,7H62.78"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-25"
                      d="M62.82,191.61s0-.09,0-.13a1.44,1.44,0,0,0,.06-.39,2.13,2.13,0,0,0,0-.43,1.86,1.86,0,0,0-.47-.89,1.72,1.72,0,0,0-1.86-.48s0,.13.27.23a2.33,2.33,0,0,1,1.69,2.09h-.14a2,2,0,0,0-2-2v-5a7,7,0,0,1,7,7H62.82"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-26"
                      d="M62.85,191.61s0,0,0,0a1.89,1.89,0,0,0-.54-1.91c-.57-.53-.75-.51-2-.39v-4.64a7,7,0,0,1,7,7h-4.5"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-27"
                      d="M62.89,191.61s0-.09,0-.13a1.94,1.94,0,0,0-2.55-2.24v-4.61a7,7,0,0,1,7,7H62.89"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-28"
                      d="M62.92,191.61c-.05-.06,0-.18.06-.27a1.34,1.34,0,0,0,0-.2,2,2,0,0,0-2.62-1.94v-4.57a7,7,0,0,1,7,7H62.92"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-29"
                      d="M63,191.61s0-.09,0-.13a2,2,0,0,0-.6-1.89,2,2,0,0,0-2-.43v-4.53a7,7,0,0,1,7,7H63"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-30"
                      d="M63,191.61s0-.12.05-.17a2.12,2.12,0,0,0,0-.38,2.16,2.16,0,0,0-.06-.47,1.88,1.88,0,0,0-.58-1,2.07,2.07,0,0,0-2.06-.43v-4.5a7,7,0,0,1,7,7H63"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-31"
                      d="M63,191.61s0,0,0-.06a2,2,0,0,0-.57-2,2.16,2.16,0,0,0-2.09-.43v-4.46a7,7,0,0,1,7,7H63"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-32"
                      d="M63.06,191.61a2.07,2.07,0,0,0-2.69-2.56v-4.42a7,7,0,0,1,7,7H63.06"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-33"
                      d="M63.11,191.61c0-.07,0-.2.07-.29a2.08,2.08,0,0,0-.61-1.9,2.2,2.2,0,0,0-2.2-.41v-4.38a7,7,0,0,1,7,7H63.11"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-34"
                      d="M63.16,191.61s0-.08,0-.11a2.13,2.13,0,0,0-.56-2.16,2.32,2.32,0,0,0-2.27-.37v-4.34a7,7,0,0,1,7,7H63.16"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-35"
                      d="M63.22,191.61a2.08,2.08,0,0,0-2.71-2.76l-.14.06v-4.28a7,7,0,0,1,7,7H63.22"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-36"
                      d="M63.31,191.61c-.05-.08.09-.21.11-.31a2.56,2.56,0,0,0,0-.27,2,2,0,0,0-.63-1.88,2.33,2.33,0,0,0-2.47-.31v-4.21a7,7,0,0,1,7,7h-4"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-37"
                      d="M63.42,191.61c.9-2.16-1-3.63-2.9-2.91a1,1,0,0,0-.15.07v-4.14a7,7,0,0,1,7,7H63.42"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-38"
                      d="M63.54,191.61a2.23,2.23,0,0,0-3-3l-.16.07v-4a7,7,0,0,1,7,7H63.54"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-39"
                      d="M63.68,191.61c.95-2.2-.9-4-3.15-3.13l-.16.08v-3.93a7,7,0,0,1,7,7H63.68"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-40"
                      d="M63.82,191.61c1.05-2.4-1-4.08-3.11-3.33l-.34.15v-3.8a7,7,0,0,1,7,7H63.82"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-41"
                      d="M64,191.61a2.48,2.48,0,0,0-3.24-3.47l-.36.16v-3.67a7,7,0,0,1,7,7H64"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-42"
                      d="M64.13,191.61c1.23-2.65-1-4.52-3.39-3.62l-.37.17v-3.53a7,7,0,0,1,7,7H64.13"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-43"
                      d="M64.31,191.61c1.32-2.72-.93-4.68-3.34-3.86a3.15,3.15,0,0,0-.6.26v-3.38a7,7,0,0,1,7,7h-3"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-44"
                      d="M64.51,191.61c1.42-2.86-1-5-3.51-4.05a5.38,5.38,0,0,0-.63.28v-3.21a7,7,0,0,1,7,7H64.51"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-45"
                      d="M64.72,191.61c1.53-2.89-.82-5.19-3.45-4.35a4.53,4.53,0,0,0-.9.4v-3a7,7,0,0,1,7,7H64.72"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-46"
                      d="M65,191.61c1.61-2.9-.72-5.4-3.39-4.69a5.12,5.12,0,0,0-1.21.53v-2.82a7,7,0,0,1,7,7H65"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-47"
                      d="M65.26,191.61c1.73-3-.79-5.76-3.57-5a4.88,4.88,0,0,0-1.32.6v-2.59a7,7,0,0,1,7,7H65.26"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-48"
                      d="M65.59,191.61a3.49,3.49,0,0,0-3.8-5.33,5.4,5.4,0,0,0-1.42.67v-2.32a7,7,0,0,1,7,7H65.59"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-49"
                      d="M66,191.61a3.86,3.86,0,0,0-4.12-5.7,4.9,4.9,0,0,0-1.47.73v-2a7,7,0,0,1,7,7H66"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-50"
                      d="M66.37,191.61c1.7-3-1.81-6.81-4.58-6.05a4.38,4.38,0,0,0-1.42.71v-1.64a7,7,0,0,1,7,7h-1"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-51"
                      d="M64,185.64a3,3,0,0,0-3.62.2v-1.21a7,7,0,0,1,3.68,1l-.06,0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-61"
                      d="M62.66,191.38a11.19,11.19,0,0,0-.64-1.12c-.31-.37-.75-.57-1.08-.9a1.5,1.5,0,0,1,1.46.58,1.41,1.41,0,0,1,.29,1.48l0,0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-52"
                      d="M62.61,185a2.57,2.57,0,0,0-2.24.37v-.74a7,7,0,0,1,2.39.42l-.15-.05"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-51"
                      d="M66.8,191.61a3.08,3.08,0,0,0,0-2.64,7,7,0,0,1,.51,2.64H66.8"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-62"
                      d="M62.64,191.26a8,8,0,0,0-.61-1c-.29-.34-.67-.56-1-.87a1.56,1.56,0,0,1,1.64,1.94l0-.06"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-63"
                      d="M62.62,191.15a7.7,7.7,0,0,0-.58-.91,9.94,9.94,0,0,0-.9-.82,1.3,1.3,0,0,1,1.22.55,1.28,1.28,0,0,1,.3,1.24l0-.06"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-64"
                      d="M62.6,191a4.55,4.55,0,0,0-.54-.82,7.64,7.64,0,0,0-.81-.76,1.4,1.4,0,0,1,1.39,1.64l0-.06"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-65"
                      d="M62.57,190.93a4.73,4.73,0,0,0-1.22-1.43,1.14,1.14,0,0,1,1,.5,1.1,1.1,0,0,1,.28,1l0-.06"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-26"
                      d="M62.35,191.61a2,2,0,0,0-2-2v-.16h.09s0,0,0,0,0,0,0,0a6,6,0,0,1,.68.23,2.18,2.18,0,0,1,.65.46,2.22,2.22,0,0,1,.64,1.46h-.12"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-53"
                      d="M61.54,184.73a2.16,2.16,0,0,0-1.17.19v-.29a7,7,0,0,1,1.31.12l-.14,0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-66"
                      d="M62.54,190.82a5.07,5.07,0,0,0-1.07-1.26,1.12,1.12,0,0,1,.84.45,1,1,0,0,1,.26.85l0,0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-27"
                      d="M62.35,191.61a2,2,0,0,0-2-2v-.13h.11a2.23,2.23,0,0,1,2,2.12h-.1"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-52"
                      d="M67.16,191.61s0,0,0,0a2.91,2.91,0,0,0,.06-1.25,7.71,7.71,0,0,1,.11,1.28h-.19"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-28"
                      d="M62.35,191.61a2,2,0,0,0-2-2v-.11h.11a2.19,2.19,0,0,1,2,2.09h-.08"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-67"
                      d="M62.51,190.71a5.39,5.39,0,0,0-.92-1.08,1.08,1.08,0,0,1,.93,1.1v0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-29"
                      d="M62.35,191.61a2,2,0,0,0-2-2v-.08h.11a2.15,2.15,0,0,1,1.93,2.07h-.06"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-30"
                      d="M62.35,191.61a2,2,0,0,0-2-2v0h.11a2.09,2.09,0,0,1,1.91,2h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-68"
                      d="M62.41,190.51a5.05,5.05,0,0,0-.68-.78,1,1,0,0,1,.72.85l0-.07"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-31"
                      d="M62.35,191.61a2,2,0,0,0-2-2v0h.1a2,2,0,0,1,1.9,2h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-69"
                      d="M62.29,190.31a5.09,5.09,0,0,0-.37-.44,1,1,0,0,1,.42.5l-.05-.06"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-54"
                      d="M60.5,184.63h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-53"
                      d="M67.35,191.61s0-.1,0-.14v.14h0"
                      transform="translate(0 -0.46)"
                    />
                  </g>
                </g>
              </g>
              <g class="cls-2">
                <g class="cls-70">
                  <g class="cls-2">
                    <path
                      class="cls-26"
                      d="M58.39,191.61h-5a7,7,0,0,1,7-7v5a2,2,0,0,0-2,2"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-26"
                      d="M60.37,189.27h0c0,.06-.06.14,0,.19h0v.16a2,2,0,0,0-2,2h-5a7,7,0,0,1,7-7v4.64"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-27"
                      d="M60.37,189.23s-.07,0-.09.06a.2.2,0,0,0,0,.17.25.25,0,0,0,.09,0v.13a2,2,0,0,0-2,2h-5a7,7,0,0,1,7-7v4.6"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-28"
                      d="M60.37,189.2a1,1,0,0,0-.18.09s-.07.13,0,.18.16,0,.22.05v.11a2,2,0,0,0-2,2h-5a7,7,0,0,1,7-7v4.57"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-29"
                      d="M60.37,189.16a.71.71,0,0,0-.39.33l.39.06v.08a2,2,0,0,0-2,2h-5a7,7,0,0,1,7-7v4.53"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-30"
                      d="M60.37,189.12a.87.87,0,0,0-.54.39,3.33,3.33,0,0,0,.54.07v0a2,2,0,0,0-2,2h-5a7,7,0,0,1,7-7v4.49"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-31"
                      d="M60.37,189.08c-.33.11-.33.11-.73.51a4.45,4.45,0,0,0,.73,0,2,2,0,0,0-2,2h-5a7,7,0,0,1,7-7v4.45"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-32"
                      d="M60.37,189a1.83,1.83,0,0,0-.92.62c-.11.4-.51.53-.72.84a2.09,2.09,0,0,0-.34,1.11h-5a7,7,0,0,1,7-7V189"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-33"
                      d="M60.37,189a3.27,3.27,0,0,0-2,2.61h-5a7,7,0,0,1,7-7V189"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-34"
                      d="M60.37,189a3.18,3.18,0,0,0-2,2.65h-5a7,7,0,0,1,7-7V189"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-35"
                      d="M60.37,188.9a3.19,3.19,0,0,0-2,2.71H53.39a7,7,0,0,1,7-7v4.27"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-36"
                      d="M60.37,188.84a3.17,3.17,0,0,0-2.07,2.77H53.39a7,7,0,0,1,7-7v4.21"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-37"
                      d="M60.37,188.77a3.16,3.16,0,0,0-2.09,2.84H53.39a7,7,0,0,1,7-7v4.14"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-38"
                      d="M60.37,188.66a3.34,3.34,0,0,0-2.11,3H53.39a7,7,0,0,1,7-7v4"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-39"
                      d="M60.37,188.55a3.35,3.35,0,0,0-2.13,3.06H53.39a7,7,0,0,1,7-7v3.92"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-40"
                      d="M60.37,188.43a3.52,3.52,0,0,0-2.16,3.18H53.39a7,7,0,0,1,7-7v3.8"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-41"
                      d="M60.37,188.3a3.76,3.76,0,0,0-2.2,3.31H53.39a7,7,0,0,1,7-7v3.67"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-42"
                      d="M60.37,188.15a4,4,0,0,0-2.23,3.46H53.39a7,7,0,0,1,7-7v3.52"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-43"
                      d="M60.37,188a4.15,4.15,0,0,0-2.27,3.61H53.39a7,7,0,0,1,7-7V188"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-44"
                      d="M60.37,187.84a4.29,4.29,0,0,0-2.31,3.77H53.39a7,7,0,0,1,7-7v3.21"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-45"
                      d="M60.37,187.66a4.49,4.49,0,0,0-2.36,4H53.39a7,7,0,0,1,7-7v3"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-46"
                      d="M60.37,187.45A4.77,4.77,0,0,0,58,191.61H53.39a7,7,0,0,1,7-7v2.82"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-47"
                      d="M60.37,187.22a5.13,5.13,0,0,0-2.46,4.39H53.39a7,7,0,0,1,7-7v2.59"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-48"
                      d="M60.37,187h0a5.52,5.52,0,0,0-2.53,4.66H53.39a7,7,0,0,1,7-7V187"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-49"
                      d="M60.37,186.64c-1.69,1.25-2.81,3.39-2.59,5H53.39a7,7,0,0,1,7-7v2"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-50"
                      d="M60.37,186.27h0c-1.71,1.3-2.93,3.75-2.66,5.34H53.39a7,7,0,0,1,7-7v1.64"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-51"
                      d="M60.37,185.84c-1.51,1.14-3,3.91-2.74,5.77H53.39a7,7,0,0,1,7-7v1.21"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-52"
                      d="M60.37,185.37h0c-1.67,1.12-3.15,4.39-2.82,6.24H53.39a7,7,0,0,1,7-7v.74"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-53"
                      d="M60.37,184.92c-1.93.92-3.25,4.91-2.92,6.69H53.39a7,7,0,0,1,7-7v.29"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-54"
                      d="M60.37,184.64h0c-2.43.32-3.38,5.41-3,7H53.39a7,7,0,0,1,7-7h0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-55"
                      d="M59.41,184.7c-2.15.42-2.55,5.62-2.23,6.91H53.39a7,7,0,0,1,6.13-6.93h0l-.11,0"
                      transform="translate(0 -0.46)"
                    />
                    <path
                      class="cls-56"
                      d="M58.18,185c-1.77.71-1.5,5.53-1.23,6.63H53.39A7,7,0,0,1,58.28,185h0l-.1,0"
                      transform="translate(0 -0.46)"
                    />
                  </g>
                </g>
              </g>
            </g>
            <text class="cls-71" transform="translate(61.41 279.51)">
              Mean monthly phosphorus
              <tspan class="cls-72" x="230.66" y="0">A</tspan>
              <tspan class="cls-73" x="242.68" y="0">U</tspan>
              <tspan x="255.36" y="0">C</tspan>
            </text>
            <text
              class="cls-71"
              transform="translate(328.91 272.85) scale(0.58)"
            >
              ‖
            </text>
            <text class="cls-71" transform="translate(34.75 335.51)">
              El
              <tspan class="cls-74" x="16.74" y="0">e</tspan>
              <tspan class="cls-75" x="27.16" y="0">v</tspan>
              <tspan class="cls-76" x="36.44" y="0">a</tspan>
              <tspan class="cls-77" x="46.58" y="0">t</tspan>
              <tspan x="53.56" y="0">ed phosph</tspan>
              <tspan class="cls-76" x="143.12" y="0">a</tspan>
              <tspan class="cls-77" x="153.26" y="0">t</tspan>
              <tspan x="160.24" y="0">e l</tspan>
              <tspan class="cls-74" x="179.56" y="0">e</tspan>
              <tspan class="cls-78" x="189.98" y="0">v</tspan>
              <tspan x="199.14" y="0">els also lead</tspan>
              <tspan class="cls-79" x="307.9" y="0">t</tspan>
              <tspan x="314.88" y="0">o</tspan>
              <tspan x="4.86" y="26">inc</tspan>
              <tspan class="cls-80" x="30.94" y="26">r</tspan>
              <tspan x="38.12" y="26">eased risk</tspan>
              <tspan class="cls-72" x="130.02" y="26">o</tspan>
              <tspan x="140.82" y="26">f M</tspan>
              <tspan class="cls-81" x="166.16" y="26">A</tspan>
              <tspan x="178.06" y="26">CE+CH</tspan>
              <tspan class="cls-82" x="237.52" y="26">F</tspan>
              <tspan x="247.52" y="26">, non-</tspan>
              <tspan class="cls-83" x="297.16" y="26">C</tspan>
              <tspan class="cls-84" x="309.16" y="26">V</tspan>
              <tspan x="20.7" y="52">mo</tspan>
              <tspan class="cls-85" x="48.16" y="52">r</tspan>
              <tspan x="55.72" y="52">talit</tspan>
              <tspan class="cls-86" x="90.04" y="52">y</tspan>
              <tspan x="98.38" y="52">, and all-cause mo</tspan>
              <tspan class="cls-85" x="254" y="52">r</tspan>
              <tspan x="261.56" y="52">tality</tspan>
            </text>
            <line class="cls-87" y1="301.3" x2="395.3" y2="301.3" />
            <g class="cls-88">
              <path
                class="cls-3"
                d="M151.79,77.07l-.7-6.9A24.48,24.48,0,0,0,148,61a3.69,3.69,0,0,0,2.83.31,3.93,3.93,0,0,0,2.34-4.79c-.61-2.13-3.23-2.13-3.23-2.13a3.81,3.81,0,0,0,.38-3.78,3.43,3.43,0,0,0-3.44-2,11.07,11.07,0,0,0,2.12-3,5.14,5.14,0,0,0-1-5.8l-2.63-1a22.06,22.06,0,0,0,.91-7.78c-.94-7.9-3.57-6.42-4.37-8.4S143,17.87,143,17.87l4.88-5.82a3.27,3.27,0,0,0-2.66-2.22s-3.71,4.18-5.38,6-3.56,4.25-3.88,3.05a5,5,0,0,1,.11-2.5l4.6-8.93c-1-1.87-4.49-1.61-4.49-1.61s-5.46,7.65-6.32,8.66-3.28,1.44-3.28,1.44a27.77,27.77,0,0,1-5-.89c-1.59-.58-1.16-2.44-1.16-2.44l-.06-11a3.93,3.93,0,0,0-3.82.28l-.28,5.32c-.83,7.3-2.89,9.37-2.89,9.37l-3.16,1.5a5.74,5.74,0,0,0-1.42-4.67A3.4,3.4,0,0,0,105,12l-3.42,2.81c-1.56-.75-3.05-3.22-3.05-3.22-2.44-3.51-5.49-8.68-5.49-8.68a17.55,17.55,0,0,0-5.48,3,6.69,6.69,0,0,0-2.66,5.34c1.68,1.81,7.63,13,7.63,13,4.58,10.64,2.38,18.25,1.49,22.2S88,60.4,88,60.4a58,58,0,0,0-6.08,15.7c-1.78,8.49,1.61,14,1.61,14L82.55,94c-3.58,12.36,3.67,18.33,8.2,23.36S111,132.63,114.24,134.3s5.83,6.79,14.21-.87,14.08-17,18.37-25.07,6.49-27.31,6.58-29.5S151.79,77.07,151.79,77.07Z"
                transform="translate(0 -0.46)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>`;
  }
}

customElements.define("disease-state", Disease);
